"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCanvasContext2d = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useCanvasContext2d = function () {
    var canvasRef = (0, react_1.useRef)(null);
    var _a = tslib_1.__read((0, react_1.useState)(undefined), 2), ctx = _a[0], setCtx = _a[1];
    (0, react_1.useEffect)(function () {
        var canvasEl = canvasRef.current;
        if (canvasEl !== null) {
            var ctx2d = canvasEl.getContext('2d');
            if (ctx2d !== null) {
                setCtx(ctx2d);
            }
        }
    }, [canvasRef, setCtx]);
    return [ctx, canvasRef];
};
exports.useCanvasContext2d = useCanvasContext2d;
